import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as setMonth from 'date-fns/set_month';
import { NzI18nService as I18n } from '../i18n/nz-i18n.service';

@Component({
  selector: 'nz-calendar-header',
  template: `<nz-select class="ant-fullcalendar-year-select" [nzSize]="size" [nzDropdownMatchSelectWidth]="false" [ngModel]="activeYear" (ngModelChange)="yearChange.emit($event)"> <nz-option *ngFor="let year of years" [nzLabel]="year.label" [nzValue]="year.value"></nz-option> </nz-select> <nz-select *ngIf="mode === 'month'" class="ant-fullcalendar-month-select" [nzSize]="size" [nzDropdownMatchSelectWidth]="false" [ngModel]="activeMonth" (ngModelChange)="monthChange.emit($event)"> <nz-option *ngFor="let month of months" [nzLabel]="month.label" [nzValue]="month.value"></nz-option> </nz-select> <nz-radio-group [(ngModel)]="mode" (ngModelChange)="modeChange.emit($event)" [nzSize]="size"> <label nz-radio-button nzValue="month">{{ monthTypeText }}</label> <label nz-radio-button nzValue="year">{{ yearTypeText }}</label> </nz-radio-group> `,
  host: {
    '[style.display]': `'block'`,
    '[class.ant-fullcalendar-header]': `true`
  }
})
export class NzCalendarHeaderComponent implements OnInit {
  @Input() mode: 'month'|'year' = 'month';
  @Output() modeChange: EventEmitter<'month'|'year'> = new EventEmitter();

  @Input() fullscreen: boolean = true;
  @Input() activeDate: Date = new Date();

  @Output() yearChange: EventEmitter<number> = new EventEmitter();
  @Output() monthChange: EventEmitter<number> = new EventEmitter();

  yearOffset: number = 10;
  yearTotal: number = 20;
  years: Array<{label: string, value: number}>;
  months: Array<{label: string, value: number}>;

  get activeYear(): number {
    return this.activeDate.getFullYear();
  }

  get activeMonth(): number {
    return this.activeDate.getMonth();
  }

  get size(): string {
    return this.fullscreen ? 'default' : 'small';
  }

  get yearTypeText(): string {
    return this.i18n.getLocale().Calendar.year;
  }

  get monthTypeText(): string {
    return this.i18n.getLocale().Calendar.month;
  }

  private prefixCls = 'ant-fullcalendar';

  constructor(private i18n: I18n) { }

  ngOnInit(): void {
    this.setUpYears();
    this.setUpMonths();
  }

  private setUpYears(): void {
    const start = this.activeYear - this.yearOffset;
    const end = start + this.yearTotal;

    this.years = [];
    for (let i = start; i < end; i++) {
      this.years.push({label: `${i}`, value: i});
    }
  }

  private setUpMonths(): void {
    this.months = [];

    for (let i = 0; i < 12; i++) {
      const dateInMonth = setMonth(this.activeDate, i);
      const monthText = this.i18n.formatDate(dateInMonth, 'MMM');
      this.months.push({label: monthText, value: i});
    }
  }
}
